<template>
  <!--====== APPIE HEADER PART START ======-->

  <header class="appie-header-area appie-header-2-area appie-sticky">
    <div class="container">
      <div class="header-nav-box">
        <div class="row align-items-center">
          <div class="col-lg-3 col-md-4 col-sm-5 col-6 order-1 order-sm-1">
            <div class="appie-logo-box">
              <!--                          {{titleWordd}}-->
              <span v-html="titleWordd"></span>

              <!--                          <span>{{title}}</span>-->
              <!--                            <a href="/">-->
              <!--                                <img src="@/assets/images/logo-2.png" alt="">-->
              <!--                            </a>-->
            </div>
          </div>
          <div class="col-lg-5 col-md-1 col-sm-1 order-3 order-sm-2">
            <div class="appie-header-main-menu" v-if="side && side.list && side.list.length > 0">
              <!--                            <nav-items :menuItems="menuItems" :nasted="nasted"/>-->

              <ul>

                <!--                              <div>{{menuItems}}</div>-->
                <li v-for="(item, index) in menuItems" :key="index">
                  <!--                              <router-link style="text-transform: capitalize;" v-if="item.path" :to="item.path">{{item.name}}</router-link>-->
                  <!--                              {{item}}-->
                  <div v-if="item.path == '/home-page'">
                    <a style="text-transform: capitalize;cursor: pointer;" v-if="item.path" @click="OpenModal(item.path,'home')"
                       :to="item.path">{{ item.name }}</a>
                    <a v-else href="#" style="text-transform: capitalize;">Profile <i v-if="nasted"
                                                                                      class="fal fa-angle-down"></i></a>
                  </div>
                  <div v-else>
                    <a style="text-transform: capitalize;" v-if="item.path" v-b-modal.modal-center1
                       @click="OpenModal(item.path, custCare)" :to="item.path">{{ item.name }}</a>
                    <a v-else href="#" style="text-transform: capitalize;">Profile <i v-if="nasted"
                                                                                      class="fal fa-angle-down"></i></a>
                  </div>
                  <!--                              <a v-else href="#" style="text-transform: capitalize;">Profile <i v-if="nasted" class="fal fa-angle-down"></i></a>-->
                  <ul v-if="item.childrens && nasted" class="sub-menu">
                    <li v-for="(subItem, index) in side.list" :key="index">
                      <!--                                  <router-link style="text-transform: capitalize;" :to="subItem.url"><img :src="subItem.icon" style="width: 30px;"><span style="margin-left: 10px;" v-html="subItem.title"></span></router-link>-->

                      <a style="text-transform: capitalize;cursor: pointer;" v-if="subItem.url !='change_mobile_number'"
                         @click="ProfileMenuOpen(subItem.activity,subItem.url)"><img :src="subItem.icon"
                                                                                     style="width: 30px;"><span
                          style="margin-left: 10px;" v-html="subItem.title"></span></a>
                    </li>
                  </ul>
                </li>

              </ul>
            </div>
          </div>

          <div class="col-lg-4  col-md-7 col-sm-6 col-6 order-2 order-sm-3">
            <div class="appie-btn-box" style="text-align:right">
              <!--                          <span style="margin-right: 10px;"><i class="fas fa-bell" ></i></span>-->
              <!--                          <span class="fa-layers fa-fw" style="margin-right: 10px;" >-->
              <!--                            <i class="fas fa-headset"></i>-->
              <!--                          </span>-->
              <div class="toggle-btn ml-30 canvas_open d-lg-none d-block">
                <i class="fa fa-bars" @click="showSidebar"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>


  <!--====== APPIE HEADER PART ENDS ======-->
</template>

<script>
// import NavItems from '../NavItems.vue'
import CryptoJS from "crypto-js";
import {common} from "@/common";

console.log(common().baseUrl)
export default {

    props: {


      side: {
        type: Object,
        required: true,
      },
      titleWordd: {
        type: String,
        required: true,
      },

      // title:{
      //   type:Object,
      //   required:true,
      // },

      menuItems: {
        type: Array,
        required: true,
      },
      nasted: {
        type: Boolean,
        default: true
      },
    },

  // components: { NavItems },

  data() {
  return {
  // title:'',


}
},

  mounted() {
  document.addEventListener('scroll', this.stickMenu)
},

  methods: {

  async OpenModal(menu, customerCare) {
  // alert(menu)
  if (menu == '/home-page') {
  await this.$router.push(menu)
} else if (menu == '/contact') {
  this.custCareDetails = customerCare;
  this.$bvModal.hide('modal-center1');
}
  // console.log(customerCare)

},

  async ProfileMenuOpen(activity, url) {
  // alert(activity)
  // alert(url)

  const inputString = activity;
  const lastPart = inputString.split('.').pop();
  // alert(lastPart);
  this.urlData = url;
  if (lastPart === 'Employer_Dynamic_Job_View') {

  const encryptedString = this.encryptUrl(url);
  await this.$router.push(`/post-view?page=${encodeURIComponent(encryptedString)}`);
} else if (lastPart === 'ViewCandidate_List') {
  const encryptedString = this.encryptUrl(url);
  await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
} else if (lastPart === 'Employer_Company_Register') {

    if(url=='https://jobspro.nithrajobs.com/api/upload/Form/Fields'){
      const encryptedString = this.encryptUrl(url);
      await this.$router.push(`/kyc-register?page=${encodeURIComponent(encryptedString)}`);
    }
    else{
      const encryptedString = this.encryptUrl(url);
      await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
    }


}
  else if (lastPart === 'MainActivity') {
    localStorage.removeItem('customerCare')
    localStorage.removeItem('token')
    localStorage.removeItem('titleWord')
    localStorage.removeItem('SideMenu')
    localStorage.removeItem('homeurl')
    await this.$router.push('/');

  }
  else if (lastPart === 'Employer_Register_Activity') {
    // await this.$router.push('/change-mobile-number');

  }
  // MainActivity logout
  // Employer_Register_Activity  mobilenum


},
  encryptUrl(url) {
  const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
  return ciphertext;
},
  decryptUrl(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
  const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
  return originalUrl;
},

  Encrypt(str) {
  // return str.split('').map(char => char.charCodeAt(0)).join('-');
  return str.replace(/[a-zA-Z]/g, function (char) {
  // Replace each alphabetic character with its encrypted value
  const charCode = char.charCodeAt(0);
  const encryptedCharCode = charCode + 1; // You can use a different encryption logic
  return String.fromCharCode(encryptedCharCode);
});
},

  showSidebar(e) {
  this.$emit("toggleSidebar", e)
},
  stickMenu() {
  const result = document.querySelector('.appie-sticky')
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
  result.classList.add('sticky')
} else {
  result.classList.remove('sticky')
}
}
}

}
</script>

<style>

</style>
